import {
  object, string, ref,
} from 'yup';
import '@client/yup';

export const SignupArtistCreateSchema = object().shape({
  compiledAddress: string().label('Location').trim().required('Location is a required field')
    .nullable()
    .dependsOrEmpty(ref('compiledAddress'), ref('latLng'), 'Please ensure you have clicked on a valid city'),
  name: string().label('Profile name').trim().max(50)
    .required(),
});
